import { useMemo, useRef, useState, useEffect } from 'react'

//* HOCs
import { withUIContext, withUserContext } from 'context'

//* Components
import { Text, ButtonFollow, Icon, ButtonSimple, CustomLink, Avatar, FormContainer, SelectViewers } from 'components/common'

//* Style
import InvitePopupStyle from './style'

const InvitePopup = ({ closePopup, popupProps, currentUser, ...props }) => {

    const { followers, participants, debateId, isFinished, viewersInvite, debateUserId } = popupProps

    const [inviting, setInviting] = useState([])
    const [participating, setParticipating] = useState([])


    const formRef = useRef()

    useEffect(() => {
        const inviters = followers.filter(follow => {
            return !participants.some(part => (part.id == follow.id || follow.id == debateUserId))
        })

        setParticipating(participants)
        setInviting(inviters)
    }, [participants, followers])


    const storePopupData = useMemo(() => {
        return participating?.map((participant, k) => (
            <div className='single-user flexBox spaceBetween alignMiddle cursorPointer' key={k}>
                <CustomLink url={`/${participant.username}`} onClick={closePopup}>
                    <div className='left flexBox'>
                        <Avatar src={participant.avatar} />
                        <div className='info flexBoxColumn'>
                            <Text tag='h5' className='PopSemi h5' text={participant.name} />
                            <Text tag='p' className='PopReg h7 darkGrey' text={`${participant.debatesCount} debates created`} />
                        </div>
                    </div>
                </CustomLink>
                <ButtonFollow followingId={participant.id} />
            </div >
        ))
    }, [participating])

    const handleInvite = (values) => {
        return props.inviteDebate({
            debateId: debateId,
            inviteIds: values.viewers
        }).then((res) => {
            formRef.current.resetFields()
            setInviting(inviting.filter(inv => !values.viewers.includes(inv.id)))
            setParticipating(res.viewers)
        });
    }

    return (
        <InvitePopupStyle className={`parent-cont flexBoxColumn alignCenter alignMiddle ${props.className}`}>
            <div className='popup-cont'>
                <Icon onClick={closePopup} className='op-close' />
                <Text tag='p' className='PopSemi h9' text={`${participating?.length} Participants`} />
                {!isFinished && (viewersInvite || debateUserId == currentUser?.id) && (
                    <FormContainer ref={formRef} onFinish={handleInvite}>
                        <div className='invite-block flexBox'>
                            <SelectViewers
                                list={inviting}
                                dropdownClassName={'viewers'}
                                rules={[
                                    { required: true, message: 'Select someone to invite' }
                                ]}
                                noDataText={'Only followers can be invited'}
                            />
                            <ButtonSimple submit className='save-btn fit' text='Invite' />
                        </div>
                    </FormContainer>
                )}
                <div className='follow-cont flexBoxColumn'>
                    {storePopupData}
                </div>
            </div>
        </InvitePopupStyle>
    )
}

export default withUIContext(withUserContext(InvitePopup,
    ['inviteDebate', 'currentUser']),
    ['closePopup', 'popupProps'])
